import { render } from "./patent_add.vue?vue&type=template&id=33faaa95&scoped=true"
import script from "./patent_add.vue?vue&type=script&lang=js"
export * from "./patent_add.vue?vue&type=script&lang=js"

import "./patent_add.vue?vue&type=style&index=0&id=33faaa95&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33faaa95"]])

export default __exports__